import { render, staticRenderFns } from "./RunGamePrevious.vue?vue&type=template&id=b496156c&scoped=true&"
import script from "./RunGamePrevious.vue?vue&type=script&lang=js&"
export * from "./RunGamePrevious.vue?vue&type=script&lang=js&"
import style0 from "./RunGamePrevious.vue?vue&type=style&index=0&id=b496156c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b496156c",
  null
  
)

export default component.exports